import { addDays, format } from "date-fns";
import { excelDateToJSDate } from "../../../utils/helpers/files/exceldatetojs";
import axios from "axios";
import moment from "moment";

export const excelColumnsPtBr = {
  "Tipo de Transfer": "transferType",
  Nome: "description",
  Origem: "origin",
  Destino: "destination",
  "Data Saída": "departureDatetime",
  "Hora Saída": "departureTime",
  "Data Chegada": "arrivalDatetime",
  "Hora Chegada": "arrivalTime",
  "Nome Do Motorista": "driverName",
  "Tipo De Veículo": "vehicleType",
  Capacidade: "seatingCapacity",
  Empresa: "company",
  "Ponto De Encontro": "meetingPoint",
  Telefone: "phone",
  Observação: "notes",
  Participantes: "participants",
  Grupos: "groups",
};

export const excelColumnsPtBrUpdate = {
  ID: "id",
  "Tipo de Transfer": "transferType",
  Nome: "description",
  Origem: "origin",
  Destino: "destination",
  "Data Saída": "departureDatetime",
  "Hora Saída": "departureTime",
  "Data Chegada": "arrivalDatetime",
  "Hora Chegada": "arrivalTime",
  "Nome Do Motorista": "driverName",
  "Tipo De Veículo": "vehicleType",
  Capacidade: "seatingCapacity",
  Empresa: "company",
  "Ponto De Encontro": "meetingPoint",
  Telefone: "phone",
  Observação: "notes",
  Participantes: "participants",
  Grupos: "groups",
};

export const excelColumnsPtBrDelete = {
  ID: "id",
  Nome: "description",
};

function formatDate(date) {
  try {
    return format(addDays(new Date(date), 1), "dd-MM-yyyy");
  } catch (error) {
    return undefined;
  }
}

function formatTime(time) {
  try {
    if (/^\d{2}:\d{2}$/.test(time) && moment(time, "HH:mm", true).isValid()) {
      return time;
    } else return undefined;
  } catch (error) {
    return undefined;
  }
}

async function getGoogleLocation(local) {
  try {
    const res = await axios.get(
      `https://us-central1-inteegra-ping.cloudfunctions.net/GoogleAutoComplete?search=${local}&language=pt`,
    );

    if (res?.data?.success?.predictions[0]) {
      return res.data.success.predictions[0].description;
    } else return local;
  } catch (erro) {
    console.log("get erro", erro);
    return local;
  }
}

export async function getGoogleData(rows) {
  for (var i = 0; i < rows.length; i++) {
    const row = rows[i];

    rows[i] = {
      ...row,
      origin: await getGoogleLocation(row.origin),
      destination: await getGoogleLocation(row.destination),
    };
  }

  return rows;
}

export function allExcelColumns(row, index) {
  const formatedRow = {
    index,
    transferType: row.transferType,
    description: row.description,
    origin: row.origin,
    destination: row.destination,
    departureDatetime: formatDate(row.departureDatetime),
    departureTime: formatTime(row.departureTime),
    arrivalDatetime: row.arrivalDatetime ? formatDate(row.arrivalDatetime) : "",
    arrivalTime: row.arrivalTime ? formatTime(row.arrivalTime) : "",
    driverName: row.driverName ? row.driverName : "",
    coordinatorName: row.coordinatorName ? row.coordinatorName : "",
    coordinatorPhone: row.coordinatorPhone ? row.coordinatorPhone : "",
    vehicleType: row.vehicleType ? row.vehicleType : "",
    seatingCapacity: row.seatingCapacity,
    company: row.company ? row.company : "",
    meetingPoint: row.meetingPoint ? row.meetingPoint : "",
    phone: row.phone ? row.phone : "",
    notes: row.notes ? row.notes : "",
    participants: row.participants ? row.participants : "",
    groups: row.groups ? row.groups : "",
  };

  return formatedRow;
}

export function allExcelColumnsUpdate(row, index) {
  const formatedRow = {
    index,
    id: row.id,
    transferType: row.transferType,
    description: row.description,
    origin: row.origin,
    destination: row.destination,
    departureDatetime: formatDate(row.departureDatetime),
    departureTime: formatTime(row.departureTime),
    arrivalDatetime: row.arrivalDatetime ? formatDate(row.arrivalDatetime) : "",
    arrivalTime: row.arrivalTime ? formatTime(row.arrivalTime) : "",
    driverName: row.driverName ? row.driverName : "",
    coordinatorName: row.coordinatorName ? row.coordinatorName : "",
    coordinatorPhone: row.coordinatorPhone ? row.coordinatorPhone : "",
    vehicleType: row.vehicleType ? row.vehicleType : "",
    seatingCapacity: row.seatingCapacity,
    company: row.company ? row.company : "",
    meetingPoint: row.meetingPoint ? row.meetingPoint : "",
    phone: row.phone ? row.phone : "",
    notes: row.notes ? row.notes : "",
    participants: row.participants ? row.participants : "",
    groups: row.groups ? row.groups : "",
  };

  return formatedRow;
}

export function allExcelColumnsDelete(row, index) {
  const formatedRow = {
    index,
    id: row.id,
    description: row.description,
  };

  return formatedRow;
}

export async function getInvalidsGroups(rows, eventId, allGroups) {
  var invalidsGroups = [];

  rows.map((e) => {
    if (!e.groups) return;

    var isValid = true;

    e.groups.split(",").map((group) => {
      const search = allGroups.find(
        (searchGroup) =>
          searchGroup.name.toUpperCase() === group.toUpperCase().trim(),
      );

      if (!search) isValid = false;
    });

    if (!isValid)
      invalidsGroups.push({
        ...e,
        groups: undefined,
      });
  });

  return invalidsGroups;
}
